export default class GlobalPropertiesController {

	public static readonly COLLECTION_PATH = "global-properties"

}